module.exports = __webpack_public_path__ + "static/media/midnight-facebook.16d35794.svg";